import React from 'react';
import { Tag } from '@chakra-ui/react';
import MaterialTable from 'material-table';
import { useSelector } from 'react-redux';

import { MATERIAL_TABLE_OPTIONS, statusClasses } from './constants';
import { CustomTableToolbar } from 'components/index';
import { tableIcons, components } from 'components/v4/MaterialTable/consts';
import { convertDateFormat } from './helper';
import dummyData from '../dummyData';

import { classNames as clx } from 'utils/classNames';
import ExportCSVButton from './ExportCSVButton';

export default function NumbersAuditTable() {
    const { darkMode } = useSelector((state) => state.settings);
    const statusRender = (status) => {
        switch (status) {
            case status:
                return (
                    <Tag className={clx(statusClasses[status], 'w-[100px]')}>
                        {status}
                    </Tag>
                );

            default:
                return null;
        }
    };
    const defaultColumns = [
        {
            title: 'Timestamp',
            field: 'DateTime',
            render: (rowData) => convertDateFormat(rowData.DateTime),
        },
        {
            title: 'User ID',
            field: 'UserID',
        },
        {
            title: 'Event Type',
            field: 'Status',
            render: (rowData) => statusRender(rowData.Status),
        },
        {
            title: 'Previous Trunk ID',
            field: 'TrunkID',
        },
        {
            title: 'New Trunk ID',
            field: 'AdminUserID',
        },
    ];
    const tableRef = React.useRef(null);
    const exportCsvOptions = {
        columns: defaultColumns,
        data: dummyData.numberHistory,
        exportCsv: tableRef?.current?.props?.options?.exportCsv,
        titleName: 'Numbers Audit',
    };
    return (
        <MaterialTable
            icons={tableIcons}
            tableRef={tableRef}
            columns={defaultColumns}
            data={dummyData.numberHistory}
            options={{
                ...MATERIAL_TABLE_OPTIONS,
                headerStyle: {
                    position: 'sticky',
                    top: 0,
                    background: darkMode ? '#121212' : 'white',
                },
            }}
            components={{
                ...components,
                Toolbar: (props) => {
                    return (
                        <CustomTableToolbar
                            {...props}
                            resetColumnsButton={false}
                        />
                    );
                },
            }}
            title={<ExportCSVButton options={exportCsvOptions} />}
        />
    );
}
